import React from 'react';
import './FloatingLabel.css';

const FloatLabelInput = ({ label, value, onChange, maxLength, uppercase, style, ...props }) => {
  const isMax = maxLength && value?.length === maxLength;

  // Opt-in auto-uppercase for alphabetic quote-form fields (BRD 03-Jul-2026).
  // Never enable this on email inputs. When enabled we uppercase the value
  // before handing the event to the caller's onChange so the stored state
  // (and any downstream payload) is uppercased too — not just the display.
  const handleChange = (e) => {
    if (uppercase && e && e.target) {
      e.target.value = e.target.value.toUpperCase();
    }
    if (onChange) onChange(e);
  };

  const mergedStyle = uppercase
    ? { textTransform: 'uppercase', ...style }
    : style;

  return (
    <div className="float-label-input">
      <input
        type="text"
        value={value}
        onChange={handleChange}
        required
        maxLength={maxLength}
        style={mergedStyle}
        {...props}
      />
      <label>{label}</label>

      {/* {maxLength && (
        <>
        {isMax && (
          <small className="char-warning">
            Maximum {maxLength} characters allowed. Kindly reduce your text.
          </small>
        )}
        </>
      )} */}
    </div>
  );
};

export default FloatLabelInput;